import { useEffect, useState, useContext } from 'react';
import { styled } from '@mui/material/styles';
import { useNavigate } from 'react-router-dom';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Alert, Box, CircularProgress, FormControl, Grid, IconButton, InputLabel, Stack, TextField, Tooltip, Typography } from '@mui/material';
import { Card, CardBody, CardHeader } from 'reactstrap';
import { DataProductoIngresado } from '../../interfaces/DataBsqProy';
import { HiPencil, HiDocumentSearch } from 'react-icons/hi';
import { Button } from '@mui/material';
import CatalogService from '../../services/CatalogService';
import { TipoProductoDTO } from '../../interfaces/TipoProductoDTO';
import { Modal as ModalStrap, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import { ProductoTerminadoDTO, getVoidProdcutoTerminadoDTO } from '../../interfaces/ProductoTerminadoDTO';
import ProductoService from '../../services/ProductoService';
import { TblProductoProdTermin, setProductoTerminado } from '../../interfaces/TblProductoProdTermin';
import { TblDecInvMotivoProdTermin, getVoidMotivo, setProductoMotivo } from '../../interfaces/TblDecInvMotivoProdTermin';
import { ProductoAreaConocimientoDTO, setProductoAreaConocimientoDTO } from '../../interfaces/ProductoAreaConocimientoDTO';
import { ProductoLineaInvestigacionDTO, setProductoLineaInvestigacionDTO } from '../../interfaces/ProductoLineaInvestigacionDTO';
import { ProductoColaboradorDTO, setListProductoColaborador } from '../../interfaces/ColaboradorProdcutoDTO';
import { ProductoTerminadoObjOdDTO, setProductoTerminadoObjOdDTO } from '../../interfaces/ProductoTerminadoObjOdDTO';
import { ObjetoLabelFilter } from '../../interfaces/ObjetoLabel';
import AlertService from '../../services/AlertService';
import { ProductoTerminSolicitanteDTO, setListProductoTerminSolicitante } from '../../interfaces/ProductoTerminSolicitanteDTO';
import { ProductoObjEspecifico, setListProductoEspecifico } from '../../interfaces/ProductoObjEspecificoDTO';
import { setListProyectoRelacionado } from '../../interfaces/ProyectoRelacionado';
import { setProductoInstitucionPais } from '../../interfaces/ProductoInstitucionPaisDTO';
import { ProductoArchivo, setListProductoArchivo } from '../../interfaces/ProductoArchivo';
import { setProductoPostGrado } from '../../interfaces/ProductoPostGradoDTO';
import { setListProductoResultado } from '../../interfaces/ProductoResultadoDTO';
import { ProductoFactorImpacto, SetListProductoFactorImpacto } from '../../interfaces/ProductoFactorImpacto';
import { ProductoAreaImplementacion, setAreaImplementacion } from '../../interfaces/ProductoAreaImplementacionDTO';
import { AiFillDelete } from 'react-icons/ai';
import { FaWindowClose, FaUserPlus } from 'react-icons/fa';
import { MdOutlineHistoryEdu } from "react-icons/md";
import { TablaProductoIngresadoDTO } from '../../interfaces/TablaProductoIngresadoDTO';
import OldProductoForm from './AsignarDoi';
import { DetalleProducto } from './DetalleProducto';
import { BsEraserFill } from 'react-icons/bs';
import { useCasUserContext } from '../../services/casUserContext';

interface Column {
    id: 'title' | 'type' | 'year' | 'creator' | 'colaborador' | 'opcions';
    label: string;
    minWidth?: number;
    align?: 'right';
    format?: (value: number) => string;
}

const columns: readonly Column[] = [
    { id: 'title', label: 'Titulo', minWidth: 170 },
    {
        id: 'type',
        label: 'Tipo',
        minWidth: 85,
    },
    {
        id: 'year',
        label: 'Año',
        minWidth: 85,
    },
    {
        id: 'creator',
        label: 'Usuario que ingresó el producto',
        minWidth: 100,
    },
    {
        id: 'colaborador',
        label: 'Colaborador del producto',
        minWidth: 80,
    },
    {
        id: 'opcions',
        label: 'Opciones',
        minWidth: 100,
    },
];

interface Data {
    name: string;
    code: string;
    population: number;
    size: number;
    density: number;
}

function createData(
    name: string,
    code: string,
    population: number,
    size: number,
): Data {
    const density = population / size;
    return { name, code, population, size, density };
}

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const catalogService = new CatalogService;
const productoService = new ProductoService();
const alertService = new AlertService();

export default function TableProductosIngresados(props: DataProductoIngresado) {
    let history = useNavigate()
    //const casUserContext = useContext(CasUserContext);
    const casUserContext = useCasUserContext();
    const idpersona = casUserContext.userData.idpersona;
    const token = casUserContext.token;
    const user = casUserContext.userData;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(props.rowsPerPage[0]);
    const [tipoProductos, setTipoProductos] = useState<Array<TipoProductoDTO>>([]);
    const [listRolColaborador, setListRolColaborador] = useState<Array<ObjetoLabelFilter>>([])
    const [modal, setModal] = useState(false);
    const [modalEliminar, setModalEliminar] = useState(false);
    const [modalEditar, setModalEditar] = useState(false);
    const [ready, setReady] = useState(false);
    const [datos, setDatos] = useState<ProductoTerminadoDTO>(() => getVoidProdcutoTerminadoDTO());
    const [filterName, setFilterName] = useState('');

    //#region Function
    async function llamarProducto(idProducto: number) {
        toggleModal();
        setReady(false);
        await productoService.GetProductoTerminadoById(idProducto, token)
            .then((data) => {
                setProducto(data);
            })
            .catch((error) => console.error(error));
    }
    async function llamarProductoEliminar(idProducto: number) {
        toggleModalEliminar();
        setReady(false);
        await productoService.GetProductoTerminadoById(idProducto, token)
            .then((data) => {
                setProducto(data)
            })
            .catch((error) => console.error(error));
    }
    async function llamarProductoEditar(idProducto: number) {
        toggleModalEditar();
        setReady(false);
        await productoService.GetProductoTerminadoById(idProducto, token)
            .then((data) => {
                setProducto(data)
            })
            .catch((error) => console.error(error));
    }
    async function eliminarProducto(idProducto: number) {
        alertService.showLoading("Espere...");
        await productoService.SoftDeleteProductoById(idProducto, token)
            .then((data) => {
                if (data.status.isSuccessfully) {
                    alertService.hideLoading();
                    alertService.alertaExito("Exito", "El producto fue eliminado y la pagina se recargara.")
                    setTimeout(() => {
                        window.location.reload();
                    }, 3000);
                } else {
                    alertService.hideLoading();
                    alertService.alertaAdvertenciaList("Alerta", data.status.messages)
                }

            })
            .catch((error) => {
                console.error(error)
            });
    }
    const handleResponseDoi = async (responseData: TblProductoProdTermin) => {
        // Manejar la respuesta aquí
        alertService.alertaExito("Exito", "Se agrego de forma exitosa, en unos segundos se recargara la pagina.");
        setTimeout(() => {
            window.location.reload();
        }, 3000);
    };
    const setIdcategoria = (data: any) => {
        return data as number
    }
    function puedeAsignarDoi(tipoproductoesperado: number): boolean {
        let bandera: boolean = false;
        if ([1, 2, 7, 9].includes(tipoproductoesperado)) {
            bandera = true;
        }
        return bandera;
    }
    function setProducto(data: any) {
        //console.log(data.data);
        setDatos({
            ...datos,
            producto: setProductoTerminado(data.data.producto) as TblProductoProdTermin,
            motivo: setProductoMotivo(data.data.motivo ?? getVoidMotivo()) as TblDecInvMotivoProdTermin,
            areaConocimiento: setProductoAreaConocimientoDTO(data.data.areaConocimiento) as ProductoAreaConocimientoDTO,
            areaImplementacion: setAreaImplementacion(data.data.areaImplementacion) as ProductoAreaImplementacion,
            lineaInvestigacion: setProductoLineaInvestigacionDTO(data.data.lineaInvestigacion) as ProductoLineaInvestigacionDTO,
            ods: setProductoTerminadoObjOdDTO(data.data.ods) as ProductoTerminadoObjOdDTO,
            colProducto: setListProductoColaborador(data.data.colProducto) as Array<ProductoColaboradorDTO>,
            solicitantes: setListProductoTerminSolicitante(data.data.solicitantes) as Array<ProductoTerminSolicitanteDTO>,
            institucion: setProductoInstitucionPais(data.data.institucion),
            archivosProd: setListProductoArchivo(data.data.archivosProd),
            proyectorel: setListProyectoRelacionado(data.data.proyectorel),
            postgrados: setProductoPostGrado(data.data.postgrados),
            objEspecificos: setListProductoEspecifico(data.data.objEspecificos) as Array<ProductoObjEspecifico>,
            factorImpacto: SetListProductoFactorImpacto(data.data.factorImpacto) as Array<ProductoFactorImpacto>,
            resultados: setListProductoResultado(data.data.resultados),
            idCategoriaProducto: setIdcategoria(data.idCategoriaProducto),
            idpersona: idpersona
        });
        setReady(true);
        //console.log(modal);
    }
    function FormTypeHandle(id: number, name: string): boolean {
        let flat = true;
        switch (id) {
            case 7://Libro/Capitulo de libro ANTIGUO
                let campos7 = ['anio', 'fechapublicacion', 'editorial', 'volumen', 'paginas', 'url', 'bdrevista', 'codISSN', 'doi', 'revisionpares'];
                flat = campos7.includes(name);
                break;
            case 17://Infraestructura/Laboratorio antiguo
                let campos17 = ['idunidad', 'tipolab', 'nevento', 'levento', 'resumen'];
                flat = campos17.includes(name);
                break;
            case 12://Infraestructura/Equipamento antiguo
                let campos12 = ['idunidad', 'levento', 'fevento', 'marca', 'modelo', 'serie', 'fechapublicacion', 'fevento', 'inventario', 'estado', 'isindex', 'frecuencia', 'asistObjetiv', 'especificacion'];
                flat = campos12.includes(name);
                break;
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                let campos = ['anio', 'url', 'doi', 'fechapublicacion', 'bdrevista', 'nombreRevista', 'codISSN', 'urlRevista', 'impactoIndex', 'impactoSJR', 'cuartil', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'adjunto'];
                flat = campos.includes(name);
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                let campos26 = ['anio', 'url', 'doi', 'fechapublicacion', 'bdrevista', 'nombreRevista', 'codISSN', 'urlRevista', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'adjunto'];
                flat = campos26.includes(name);
                break;
            case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
                let campos25 = ['anio', 'url', 'doi', 'fechapublicacion', 'nombreRevista', 'codISSN', 'revisionpares', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'adjunto', 'adjunto2'];
                flat = campos25.includes(name);
                break;
            case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
                let campos27 = ['anio', 'url', 'doi', 'fechapublicacion', 'nombreRevista', 'codISSN', 'palabrasClave', 'resumen', 'adjunto'];
                flat = campos27.includes(name);
                break;
            case 28://Libro/Capitulo de libro
                let campos28 = ['anio', 'fechapublicacion', 'editorial', 'volumen', 'paginas', 'url', 'bdrevista', 'codISSN', 'doi', 'revisionpares', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos28.includes(name);
                break;
            case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
                let campos29 = ['url', 'fevento', 'palabrasClave', 'objGeneral', 'objEspecificos', 'programaPostgrado', 'resumen', 'adjunto', 'adjunto2'];
                flat = campos29.includes(name);
                break;
            case 30://TESIS DE DOCTORADO
                let campos30 = ['url', 'fevento', 'palabrasClave', 'objGeneral', 'objEspecificos', 'programaPostgrado', 'resumen', 'adjunto', 'adjunto2'];
                flat = campos30.includes(name);
                break;
            case 31://ABSTRACT CONFERENCIA
                let campos31 = ['url', 'nombreRevista', 'codISSN', 'nevento', 'levento', 'fevento', 'palabrasClave', 'adjunto', 'adjunto2'];
                flat = campos31.includes(name);
                break;
            case 32://Solicitud de Patente
                let campos32 = ['solicitantes', 'numsolicitud', 'subclase', 'proyectorel', 'casillaMateriaInt', 'casillaPais', 'idpais', 'instTitular', 'nevento', 'fechapublicacion', 'fevento', 'iddecinvobjods', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'resumen', 'palabrasClave', 'adjunto', 'adjunto2', 'adjunto3', 'adjunto4', 'adjunto5'];
                flat = campos32.includes(name);
                break;
            case 33://Derecho de Autor
                let campos33 = ['solicitantes', 'numsolicitud', 'iddecinvobjods', 'subclase', 'casillaMateriaInt', 'fevento', 'especificacion', 'adjunto', 'adjunto2'];
                flat = campos33.includes(name);
                break;
            case 34://NUEVA OBTENCION VEGETAL
                let campos34 = ['solicitantes', 'numsolicitud', 'proyectorel', 'casillaPais', 'idpais', 'instTitular', 'nevento', 'fechapublicacion', 'fevento', 'iddecinvobjods', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'resumen', 'palabrasClave', 'adjunto', 'adjunto2'];
                flat = campos34.includes(name);
                break;
            case 35://CASO ESTUDIO
                let campos35 = ['url', 'fechapublicacion', 'nombreRevista', 'objEspecificos', 'resultados', 'resumen', 'especificacion', 'adjunto', 'adjunto2'];
                flat = campos35.includes(name);
                break;
            case 36://POSTER CONFERENCIA
                let campos36 = ['nombreRevista', 'nevento', 'levento', 'fevento', 'adjunto', 'adjunto2'];
                flat = campos36.includes(name);
                break;
            case 37://Infraestructura/Equipamento
                let campos37 = ['idunidad', 'levento', 'marca', 'modelo', 'serie', 'fechapublicacion', 'fevento', 'inventario', 'estado', 'isindex', 'frecuencia', 'especificacion', 'adjunto'];
                flat = campos37.includes(name);
                break;
            case 38://Infraestructura/Laboratorio
                let campos38 = ['idunidad', 'tipolab', 'nevento', 'levento', 'resumen', 'adjunto'];
                flat = campos38.includes(name);
                break;
            case 39://Organización y ejecución de Taller/Curso/Conferencia
                let campos39 = ['nevento', 'especificacion', 'levento', 'fevento', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos39.includes(name);
                break;
            case 40://Metodología/Protocolo implementado
                let campos40 = ['codigoproducto', 'especificacion', 'areaimplementacion', 'adjunto', 'adjunto2', 'adjunto3', 'adjunto4', 'adjunto5'];
                flat = campos40.includes(name);
                break;
            case 41://Proyecto de titulación de Grado
                let campos41 = ['url', 'palabrasClave', 'objGeneral', 'objEspecificos', 'resumen', 'fevento', 'adjunto'];
                flat = campos41.includes(name);
                break;
            case 42://Proyecto de titulación de maestría profesional
                let campos42 = ['url', 'palabrasClave', 'objGeneral', 'objEspecificos', 'programaPostgrado', 'resumen', 'fevento', 'adjunto', 'adjunto2'];
                flat = campos42.includes(name);
                break;
            case 43://Participación en conferencia
                let campos43 = ['nombreRevista', 'nevento', 'levento', 'fevento', 'adjunto'];
                flat = campos43.includes(name);
                break;
            case 44://Secreto Empresarial o información no divulgada
                let campos44 = ['casillaMateriaInt', 'iddecinvobjods', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'fevento', 'adjunto', 'adjunto2'];
                flat = campos44.includes(name);
                break;
            case 45://Informes técnicos de resultados de investigación (Arqueología)
                let campos45 = ['solicitantes', 'subclase', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'anio', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos45.includes(name);
                break;
            case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
                let campos46 = ['anio', 'url', 'doi', 'fechapublicacion', 'bdrevista', 'nombreRevista', 'codISSN', 'urlRevista', 'impactoIndex', 'impactoSJR', 'cuartil', 'volumen', 'paginas', 'palabrasClave', 'resumen', 'iddecinvareaconocimiento', 'lineainvestigacion', 'codarea', 'codsubarea', 'codsubareadetallada', 'adjunto', 'adjunto2', 'adjunto3'];
                flat = campos46.includes(name);
                break;
            case 47://PRODUCTO TRANSICION
                let campos47 = ['anio', 'url', 'doi', 'subclase', 'adjunto', 'adjunto2', 'adjunto3', 'adjunto4'];
                flat = campos47.includes(name);
                break;
            default:
                flat = false;
                break;
        }
        return flat;
    }
    function FormSubClassHandle(id: number, name: string): boolean {
        let flat = true;
        switch (id) {
            case 3830://Planta transgenica
                let campos1 = ['fechapublicacion', 'asistObjetiv', 'innovaVerific', 'logrosSistemac', 'retosComunic'];
                flat = campos1.includes(name);
                break;
            case 3831://Prototipo
                let campos2 = ['fechapublicacion', 'palabrasClave', 'resumen', 'logrosSistemac'];
                flat = campos2.includes(name);
                break;
            case 3832://Secuencia sintética
                let campos3 = ['objGeneral'];
                flat = campos3.includes(name);
                break;
            case 3833://Software
                let campos4 = ['especificacion'];
                flat = campos4.includes(name);
                break;
            case 3834://Vacuna
                let campos5 = ['fechapublicacion', 'palabrasClave', 'resumen', 'logrosSistemac'];
                flat = campos5.includes(name);
                break;
            case 3835://Transferencia tecnologia
                let campos6 = ['idunidad', 'resumen', 'asistObjetiv'];
                flat = campos6.includes(name);
                break;
            default:
                flat = false;
                break;
        }
        return flat;
    }
    function LabelHandle(id: number, name: string): string {
        let label = "";
        switch (id) {
            case 0:
                switch (name) {
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 24://ARTÍCULO CIENTÍFICO (SCOPUS/WOS)
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Artículo científico'
                        break;
                    case 'adjunto2':
                        label = 'Certificado de asistencia a conferencia';
                        break;
                    case 'adjunto3':
                        label = 'diapositivas (En caso de que aplique)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'cuartil':
                        label = 'Cuartil';
                        break;
                    case 'impactoIndex':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSJR':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSciScore':
                        label = 'Factor Impacto: ';
                        break;
                    case 'cuartilCiteScore':
                        label = 'Cuartil';
                        break;
                    case 'esPrimerDecilCiteScore':
                        label = '¿Es Primer Decil?';
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'urlRevista':
                        label = 'Url de la revista / Memoria de Evento: '
                        break;
                    case 'volumen':
                        label = 'Volumen: ';
                        break;
                    case 'paginas':
                        label = 'Páginas: ';
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación y vinculación: ';
                        break;
                    case 'bdrevista':
                        label = 'Tipo de indexación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 25://ARTÍCULO CIENTÍFICO (OTRAS INDEXACIONES)
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Artículo científico'
                        break;
                    case 'adjunto2':
                        label = 'Certificado de asistencia a conferencia';
                        break;
                    case 'adjunto3':
                        label = 'Diapositivas';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'cuartil':
                        label = 'Cuartil';
                        break;
                    case 'impactoIndex':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSJR':
                        label = 'Factor Impacto: ';
                        break;
                    case 'cuartilCiteScore':
                        label = 'Cuartil';
                        break;
                    case 'esPrimerDecilCiteScore':
                        label = '¿Es Primer Decil?';
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'urlRevista':
                        label = 'Url de la revista / Memoria de Evento: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'volumen':
                        label = 'Volumen: ';
                        break;
                    case 'paginas':
                        label = 'Páginas: ';
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'urlRevista':
                        label = 'Url de la revista / Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación y vinculación: ';
                        break;
                    case 'bdrevista':
                        label = 'Tipo de indexación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 26://ARTÍCULO CIENTÍFICO (SIN INDEXACIÓN)
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Artículo científico';
                        break;
                    case 'adjunto2':
                        label = 'Prueba de Revisión de Pares - Obligatorio si tuvo revisión por pares';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'cuartil':
                        label = 'Cuartil';
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'paginas':
                        label = 'Páginas: ';
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'volumen':
                        label = 'Volumen: ';
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }

                break;
            case 27://ARTÍCULO DE DIVULGACIÓN CIENTÍFICA
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Artículo de divulgación científica';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 28://Libro/Capitulo de libro
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del libro o capítulo de libro';
                        break;
                    case 'adjunto2':
                        label = 'Prueba de Revisión de Pares';
                        break;
                    case 'adjunto3':
                        label = 'Notificación de Aceptación';
                        break;
                    case 'codISSN':
                        label = 'Código Normalización (ISBN/ISSN): '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'url':
                        label = 'Url: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'paginas':
                        label = 'Páginas: ';
                        break;
                    case 'bdrevista':
                        label = 'Tipo de indexación';
                        break;
                    case "doi":
                        label = "DOI: ";
                        break;
                    case "revisionpares":
                        label = "Tuvo Revisión por Pares (SI/NO): ";
                        break;
                    case 'volumen':
                        label = 'Volumen: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 29://TESIS MAESTRÍA DE INVESTIGACIÓN
                switch (name) {
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'fevento':
                        label = '*Fecha de titulación: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'idprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'nombreprograma':
                        label = '*Nombre del programa de postgrado: '
                        break;
                    case 'instituciontitularPG':
                        label = '*Institución titular del programa de posgrado: '
                        break;
                    case 'adjunto':
                        label = '*Adjuntar PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos Especificos';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 30://TESIS DE DOCTORADO
                switch (name) {
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'fevento':
                        label = 'Fecha de titulación: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'objGeneral':
                        label = 'Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos Especificos';
                        break;
                    case 'idprograma':
                        label = 'Nombre del programa de postgrado: '
                        break;
                    case 'nombreprograma':
                        label = 'Nombre del programa de postgrado: '
                        break;
                    case 'instituciontitularPG':
                        label = 'Institución titular del programa de posgrado: '
                        break;
                    case 'adjunto':
                        label = 'PDF de tesis'
                        break;
                    case 'adjunto2':
                        label = 'Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 31://ABSTRACT CONFERENCIA
                switch (name) {
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'codISSN':
                        label = 'Código ISSN / ISBN de las memorias de conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras claves: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = 'Abstract presentado en la conferencia'
                        break;
                    case 'adjunto2':
                        label = 'Certificado de participación en la conferencia'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 32://Solicitud de Patente
                switch (name) {
                    case 'adjunto':
                        label = 'Figuras';
                        break;
                    case 'adjunto2':
                        label = 'Descripción';
                        break;
                    case 'adjunto3':
                        label = 'Solicitud de ingreso de Patente';
                        break;
                    case 'adjunto4':
                        label = 'Notificación de ingreso de Patente';
                        break;
                    case 'adjunto5':
                        label = 'PDF de la Patente';
                        break;
                    case 'solicitantes':
                        label = '*Solicitantes o titulares (nombre de institución / persona, porcentaje de titularidad): ';
                        break;
                    case 'subclase':
                        label = '*Tipo de patente: ';
                        break;
                    case 'numsolicitud':
                        label = 'Número de Solicitud: ';
                        break;
                    case 'proyectorel':
                        label = 'Proyectos relacionados: ';
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'casillaPais':
                        label = 'Si proviene de otro país';
                        break;
                    case 'idpais':
                        label = 'País';
                        break;
                    case 'instTitular':
                        label = '*Institución que realiza la solicitud: ';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = '*Ente/Organismo competente: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha de presentación a la Oficina Institucional de PI: '
                        break;
                    case 'fevento':
                        label = '*Fecha de presentación al Ente / Organismo competente: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen técnico: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = '*ODS al que contribuye el producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 33://Derecho de Autor
                switch (name) {
                    case 'adjunto':
                        label = 'Registro de derecho de autor'
                        break;
                    case 'adjunto2':
                        label = 'Notificación de registro'
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'subclase':
                        label = 'Clase de obra: ';
                        break;
                    case 'solicitantes':
                        label = '*Titulares (nombre de institución / persona, porcentaje de titularidad): ';
                        break;
                    case 'numsolicitud':
                        label = '*N° certificado: ';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = '*Fecha de registro: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = '*Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = '*ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                }
                break;
            case 34://NUEVA OBTENCION VEGETAL
                switch (name) {
                    case 'adjunto':
                        label = 'Solicitud de ingreso de Derecho Obtentor'
                        break;
                    case 'adjunto2':
                        label = 'Notificación de ingreso de Derecho Obtentor'
                        break;
                    case 'solicitantes':
                        label = 'Solicitantes o titulares (nombre de institución / persona, porcentaje de titularidad): ';
                        break;
                    case 'subclase':
                        label = 'Tipo de patente: ';
                        break;
                    case 'numsolicitud':
                        label = 'Número de Solicitud: ';
                        break;
                    case 'proyectorel':
                        label = 'Proyectos relacionados: ';
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'casillaPais':
                        label = 'Si proviene de otro país';
                        break;
                    case 'idpais':
                        label = 'País';
                        break;
                    case 'instTitular':
                        label = 'Institución que realiza la solicitud: ';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Ente / Organismo competente: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha de presentación al Ente / Organismo competente: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'paginas':
                        label = 'Páginas: ';
                        break;
                    case 'resumen':
                        label = 'Resumen Técnico: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha de presentación a la Oficina Institucional de PI: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación y vinculación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 35://caso Estudio
                switch (name) {
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de revista: '
                        break;
                    case 'especificacion':
                        label = 'Metodología: '
                        break;
                    case 'logrosSistemac':
                        label = 'Sistematicidad: ';
                        break;
                    case 'retosComunic':
                        label = 'Comunicabilidad: ';
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos ';
                        break;
                    case 'resultados':
                        label = 'Resultados';
                        break;
                    case 'adjunto':
                        label = 'PDF del caso de estudio';
                        break;
                    case 'adjunto2':
                        label = 'Otra Evidencia'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 36://POSTER CONFERENCIA
                switch (name) {
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'adjunto':
                        label = 'Póster de la conferencia';
                        break;
                    case 'adjunto2':
                        label = 'Certificado de participación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 37://Infraestructura/Equipamento
                switch (name) {
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Área / Laboratorio: '
                        break;
                    case 'fevento':
                        label = 'Último Mantenimiento - Obligatorio solo si escoge la opción de "USADO": '
                        break;
                    case 'marca':
                        label = 'Marca: '
                        break;
                    case 'modelo':
                        label = 'Modelo: '
                        break;
                    case 'serie':
                        label = 'Número de Serie (ID): '
                        break;
                    case 'inventario':
                        label = 'Número Inventario de ESPOL/ESPOLTECH: '
                        break;
                    case 'estado':
                        label = 'Estado: '
                        break;
                    case 'frecuencia':
                        label = 'Frecuencia de USO: '
                        break;
                    case 'asistObjetiv':
                        label = 'Usuarios: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha de Compra: '
                        break;
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'especificacion':
                        label = 'Especificación Técnica: '
                        break;
                    case 'idunidad':
                        label = '*Unidad: '
                        break;
                    case 'isindex':
                        label = 'Condiciones de Brindar Servicio: '
                        break;
                    case 'adjunto':
                        label = 'Ficha técnica del Equipo';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 38://Infraestructura/Laboratorio
                switch (name) {
                    case 'nevento':
                        label = 'Nombre Laboratorio: '
                        break;
                    case 'levento':
                        label = 'Ubicación: '
                        break;
                    case 'tipolab':
                        label = 'Tipo de Laboratorio: '
                        break;
                    case 'palabrasClave':
                        label = 'Responsable: '
                        break;
                    case 'resumen':
                        label = 'Áreas del Laboratorio: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'adjunto':
                        label = 'Informe de creación de laboratorio (imágenes)';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 39://Organización y ejecución de Taller/Curso/Conferencia
                switch (name) {
                    case 'nevento':
                        label = 'Temática: '
                        break;
                    case 'levento':
                        label = 'Lugar: '
                        break;
                    case 'fevento':
                        label = 'Fecha: '
                        break;
                    case 'asistObjetiv':
                        label = 'Asistentes: '
                        break;
                    case 'especificacion':
                        label = 'Requisitos: '
                        break;
                    case 'adjunto':
                        label = 'Presentación del taller';
                        break;
                    case 'adjunto2':
                        label = 'Listado de asistencia';
                        break;
                    case 'adjunto3':
                        label = 'Otro tipo de Evidencia';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 40://Metodología/Protocolo implementado
                switch (name) {
                    case 'codigoproducto':
                        label = 'Código: '
                        break;
                    case 'especificacion':
                        label = 'Especificaciones: '
                        break;
                    case 'areaimplementacion':
                        label = 'Área de Implementación: ';
                        break;
                    case 'adjunto':
                        label = 'PDF del Producto';
                        break;
                    case 'adjunto2':
                        label = 'Notificación de Aceptación(En caso de que exista)';
                        break;
                    case 'adjunto3':
                        label = 'Prueba de Revisión de Pares(En caso de ser requerido)';
                        break;
                    case 'adjunto4':
                        label = 'Otro tipo de Evidencia';
                        break;
                    case 'adjunto5':
                        label = 'Planes de manejo y conservación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 41://Proyecto de titulación grado
                switch (name) {
                    case 'fevento':
                        label = '*Fecha de Titulación: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = '*Objetivos Especificos';
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'adjunto':
                        label = '*Proyecto integrador (Registrado en CIB)'
                        break;
                    case 'adjunto2':
                        label = '*Diploma o certificado de titulación'
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 42://Proyecto de titulación de maestría profesional
                switch (name) {
                    case 'fevento':
                        label = 'Fecha de Titulación: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'objGeneral':
                        label = '*Objetivo General: '
                        break;
                    case 'objEspecificos':
                        label = 'Objetivos Especificos';
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'idprograma':
                        label = 'Nombre del programa de postgrado: '
                        break;
                    case 'nombreprograma':
                        label = 'Nombre del programa de postgrado: '
                        break;
                    case 'instituciontitularPG':
                        label = 'Institución titular del programa de posgrado: '
                        break;
                    case 'adjunto':
                        label = 'PDF de tesis';
                        break;
                    case 'adjunto2':
                        label = 'Diploma o certificado de titulación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 43://Participación en conferencia
                switch (name) {
                    case 'nombreRevista':
                        label = 'Organizadores de la conferencia: '
                        break;
                    case 'nevento':
                        label = 'Nombre de conferencia: '
                        break;
                    case 'levento':
                        label = 'Lugar del evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha del evento: '
                        break;
                    case 'adjunto':
                        label = 'Certificado de participación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 44://Secreto Empresarial o información no divulgada
                switch (name) {
                    case 'adjunto':
                        label = 'Notificación de registro'
                        break;
                    case 'adjunto2':
                        label = 'Registro del depósito de información no divulgada (Secreto)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'casillaMateriaInt':
                        label = 'Si proviene de Materia integradora';
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha de registro: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 45://Informes técnicos de resultados de investigación (Arqueología)
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Informe aprobado'
                        break;
                    case 'adjunto2':
                        label = 'Evidencia de aprobación del documento';
                        break;
                    case 'adjunto3':
                        label = 'Fichas de inventario';
                        break;
                    case 'subclase':
                        label = 'Tipo de informe: ';
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'solicitantes':
                        label = 'Nombre de Institución externa: ';
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'paginas':
                        label = 'Páginas: ';
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break
            case 46://ARTÍCULO DE CONFERENCIA (SCOPUS/WOS)
                switch (name) {
                    case 'adjunto':
                        label = '*Adjuntar PDF del Artículo científico'
                        break;
                    case 'adjunto2':
                        label = '*Certificado de asistencia a conferencia';
                        break;
                    case 'adjunto3':
                        label = 'Adjuntar diapositivas (En caso de que aplique)';
                        break;
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'cuartil':
                        label = 'Cuartil';
                        break;
                    case 'impactoIndex':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSJR':
                        label = 'Factor Impacto: ';
                        break;
                    case 'impactoSciScore':
                        label = 'Factor Impacto: ';
                        break;
                    case 'cuartilCiteScore':
                        label = 'Cuartil';
                        break;
                    case 'esPrimerDecilCiteScore':
                        label = '¿Es Primer Decil?';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case "revisionpares":
                        label = "Tiene revisión por pares: ";
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'urlRevista':
                        label = '*Url de la revista / Memoria de Evento: '
                        break;
                    case 'volumen':
                        label = '*Volumen: ';
                        break;
                    case 'paginas':
                        label = '*Páginas: ';
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = '*Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = '*Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = '*Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = '*Año de Publicación: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = '*Área prioritarias de investigación y vinculación: ';
                        break;
                    case 'lineainvestigacion':
                        label = '*Línea de investigación y vinculación: ';
                        break;
                    case 'bdrevista':
                        label = '*Tipo de indexación';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            case 47://PRODUCTO DE TRANSCISION
                switch (name) {
                    case 'adjunto':
                        label = ''
                        break;
                    case 'adjunto2':
                        label = '';
                        break;
                    case 'adjunto3':
                        label = '';
                        break;
                    case 'adjunto4':
                        label = '';
                        break;
                    case 'anio':
                        label = '*Año: ';
                        break;
                    case "doi":
                        label = "*DOI: ";
                        break;
                    case "especificacion":
                        label = "*Especificaciones: ";
                        break;
                    case "objGeneral":
                        label = "*Propósito: ";
                        break;
                    case 'palabrasClave':
                        label = '*Palabras Claves: '
                        break;
                    case 'resumen':
                        label = '*Resumen: '
                        break;
                    case 'idunidad':
                        label = '*Unidad: '
                        break;
                    case 'fechapublicacion':
                        label = '*Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = '*Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'subclase':
                        label = '*Producto Específico: ';
                        break;
                    case 'url':
                        label = '*Url de Publicación: '
                        break;
                    case 'asistObjetiv':
                        label = '';
                        break;
                    case 'innovaVerific':
                        label = '';
                        break;
                    case 'logrosSistemac':
                        label = '';
                        break;
                    case 'retosComunic':
                        label = '';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
            default:
                switch (name) {
                    case 'codISSN':
                        label = 'Código ISSN de la Revista: '
                        break;
                    case 'nevento':
                        label = 'Nombre Evento: '
                        break;
                    case 'levento':
                        label = 'Lugar Evento: '
                        break;
                    case 'fevento':
                        label = 'Fecha Evento: '
                        break;
                    case 'palabrasClave':
                        label = 'Palabras Claves: '
                        break;
                    case 'resumen':
                        label = 'Resumen: '
                        break;
                    case 'idunidad':
                        label = 'Unidad: '
                        break;
                    case 'tipolab':
                        label = 'Tipo Laboratorio: '
                        break;
                    case 'fechapublicacion':
                        label = 'Fecha Publicación: '
                        break;
                    case 'editorial':
                        label = 'Editorial: '
                        break;
                    case 'nombreRevista':
                        label = 'Nombre de Revista/ Memoria de Evento: '
                        break;
                    case 'url':
                        label = 'Url de Publicación: '
                        break;
                    case 'especificacion':
                        label = 'Especificación: '
                        break;
                    case 'iddecinvobjods':
                        label = 'ODS del producto: '
                        break;
                    case 'codarea':
                        label = 'Área CINE/UNESCO: '
                        break;
                    case 'codsubarea':
                        label = 'Sub-área CINE/UNESCO: '
                        break;
                    case 'codsubareadetallada':
                        label = 'Sub-área detallada CINE/UNESCO: '
                        break;
                    case 'anio':
                        label = 'Año: ';
                        break;
                    case 'iddecinvareaconocimiento':
                        label = 'Área de investigación: ';
                        break;
                    case 'lineainvestigacion':
                        label = 'Línea de investigación: ';
                        break;
                    case 'asistObjetiv':
                        label = 'Objetividad: ';
                        break;
                    case 'innovaVerific':
                        label = 'Verificabilidad: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Sistematicidad: ';
                        break;
                    case 'retosComunic':
                        label = 'Comunicabilidad: ';
                        break;
                    default:
                        label = name;
                        break;
                }
                break;
        }
        return label;
    }
    function FormSubclaseLabelHandle(idsubclase: number, name: string): string {
        let label = ''
        switch (idsubclase) {
            case 3830://Planta transgenica
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = 'Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = 'Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = 'Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3831://Prototipo
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Notificación de Aceptación';
                        break;
                    case 'adjunto3':
                        label = 'Prueba de Revisión de Pares';
                        break;
                    case 'adjunto4':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = 'Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = 'Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Colecciones: ';
                        break;
                    case 'retosComunic':
                        label = 'Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3832://Secuencia sintética
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = 'Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = 'Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = 'Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3833://Software
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = 'Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = 'Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = 'Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3834://Vacuna
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = 'Plantas modificadas genéticamente: ';
                        break;
                    case 'innovaVerific':
                        label = 'Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Colecciones: ';
                        break;
                    case 'retosComunic':
                        label = 'Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            case 3835://Transferencia tecnologia
                switch (name) {
                    case 'adjunto':
                        label = 'PDF del Producto'
                        break;
                    case 'adjunto2':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto3':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'adjunto4':
                        label = 'Otro tipo de evidencia';
                        break;
                    case 'asistObjetiv':
                        label = 'Patentes Otorgadas: ';
                        break;
                    case 'innovaVerific':
                        label = 'Transformación genética: ';
                        break;
                    case 'logrosSistemac':
                        label = 'Herramientas: ';
                        break;
                    case 'retosComunic':
                        label = 'Conclusiones: ';
                        break;
                    default:
                        label = '';
                        break;
                }
                break;
            default:
                label = '';
        }
        return label;
    }
    function linkDspace(ideref: string): string {
        if (ideref === '' || ideref === null) {
            return '';
        }
        let listaArray: string[] = ideref.split(",");
        let enlace = 'http://192.168.1.125/rest/bitstreams/{ideref}/retrieve';
        enlace = enlace.replace("{ideref}", listaArray[1]);
        return enlace;
    }
    function conseguirRefarchivo(archivos: Array<ProductoArchivo>, numero: number) {
        const archivoEncontrado = archivos.find(x => x.numero === numero);
        // Verifica si se encontró el archivo y refarchivo no es undefined o null
        if (archivoEncontrado && archivoEncontrado.refarchivo !== undefined && archivoEncontrado.refarchivo !== null) {
            // Hacer algo con el valor de refarchivo
            return archivoEncontrado.refarchivo;
            // Resto de tu código aquí
        } else {
            return "";
        }
    }
    const toggleModal = () => {
        setModal(!modal);
    };
    const toggleModalEliminar = () => {
        setModalEliminar(!modalEliminar);
    };
    const toggleModalEditar = () => {
        setModalEditar(!modalEditar);
    };
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };
    const goToNavigation = (site: string) => {
        history(site)
    }
    function filtrarPorTitulo(value: string) {
        setFilterName(value)
    }
    const filtrarDatos = (datos: Array<TablaProductoIngresadoDTO>, filtro: string) => {
        return datos.filter(row => row.producto.titulo.toLowerCase().includes(filtro.toLowerCase()));
    };
    //#endregion
    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));
    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: theme.palette.action.hover,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
        },
    }));
    //#region UseEffect
    useEffect(() => {
        const fetchData = async () => {
            try {
                catalogService.obtenerAllTipoProducto()
                    .then((data) => setTipoProductos(data.listData))
                    .catch((error) => console.error(error))
                setListRolColaborador(catalogService.getRolColaboradorProducto)
            } catch (error) {
                console.error('Error:', error);
            }
        };
        fetchData();
    }, []);
    //#endregion

    return (
        <Paper sx={{ width: '100%', overflow: 'hidden' }}>
            <Card>
                <CardHeader><strong>{props.titulo ? props.titulo : 'Productos ingresados por el Investigador'}</strong></CardHeader>
                {props.data.length > 0 ?
                    <Box sx={{ p: 1 }}>
                        <TextField id="outlined-basic" label="Buscar..." variant="outlined" onChange={e => filtrarPorTitulo(e.target.value)} />
                    </Box>
                    : <></>}
                <CardBody>
                    {props.mostrarAlert ?
                        <Alert severity="info">
                            {props.mensajeAlert ? props.mensajeAlert
                                : "Estimado Investigador, los productos que aparecen en esta tabla son aquellos que usted ha ingresado en la plataforma, así pertenezcan a un proyecto registrado en la plataforma o no."}
                        </Alert>
                        : <></>}
                    <br />
                    <Alert severity="success">
                      Estimado Investigador, los productos cuyo titulo inicie con <BsEraserFill /> son productos en estado borrador que no se presentaran en los diferentes servicios relacionados a publicaciones.
                    </Alert>
                    <br />
                    <TableContainer sx={{ maxHeight: 600 }}>
                        <Table>
                            <TableHead>
                                <TableRow style={{ zIndex: 0 }}>
                                    {columns.map((column) => (
                                        <StyledTableCell
                                            style={{ minWidth: column.minWidth }}
                                            key={column.id}
                                            align={column.align}>
                                            {column.label}
                                        </StyledTableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            {props.ready ?
                                <TableBody>
                                    {filtrarDatos(props.data, filterName).length > 0 ? filtrarDatos(props.data, filterName)
                                        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        .map((row) => {
                                            return (
                                                <StyledTableRow key={row.producto.iddecinvproyectoprodtermin}>
                                                    <StyledTableCell component="th" scope="row">
                                                        {row.producto.estadoproducto === 'G' ? <BsEraserFill /> : ''} {row.producto.titulo}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left">
                                                        {row.nombreTipoProducto}
                                                    </StyledTableCell>
                                                    <StyledTableCell align="left">{row.producto.anio}</StyledTableCell>
                                                    <StyledTableCell align="left">{row.usuarioIngreso}</StyledTableCell>
                                                    <StyledTableCell align="left">{row.colaborador ? 'Si' : 'No'}</StyledTableCell>
                                                    <StyledTableCell align="left">
                                                        <Tooltip title={"Ver"} placement="top" arrow >
                                                            <IconButton aria-label="ver"
                                                                color='success' onClick={() => { llamarProducto(row.producto.iddecinvproyectoprodtermin) }}>
                                                                <HiDocumentSearch />
                                                            </IconButton>
                                                        </Tooltip>
                                                        {row.producto.iddecinvtipoproductoesperado > 23 ?
                                                            <Tooltip title={"Editar"} placement="top" arrow >
                                                                <IconButton aria-label="editar"
                                                                    color="primary" onClick={() => { goToNavigation('/Producto/formularioproducto/' + row.producto.iddecinvproyectoprodtermin) }}>
                                                                    <HiPencil />
                                                                </IconButton>
                                                            </Tooltip>
                                                            : <></>}
                                                        {row.producto.iddecinvtipoproductoesperado <= 23 ?
                                                            <Tooltip title={"Agregar Colaborador"} placement="top" arrow >
                                                                <IconButton aria-label="editar"
                                                                    color="primary" onClick={() => { goToNavigation('/Producto/addColaboradorProducto/' + row.producto.iddecinvproyectoprodtermin) }}>
                                                                    <FaUserPlus />
                                                                </IconButton>
                                                            </Tooltip>
                                                            : <></>}
                                                        {row.motivo.idpersona === user.idpersona ?
                                                            <Tooltip title={"Eliminar"} placement="top" arrow >
                                                                <IconButton aria-label="eliminar"
                                                                    color="error" onClick={() => { llamarProductoEliminar(row.producto.iddecinvproyectoprodtermin) }}>
                                                                    <AiFillDelete />
                                                                </IconButton>
                                                            </Tooltip>
                                                            : <></>}
                                                        {(row.producto.doi === '' || row.producto.doi === null || row.producto.url === '' || row.producto.url === null) && puedeAsignarDoi(row.producto.iddecinvtipoproductoesperado) ?
                                                            <Tooltip title={"Asignar Doi"} placement="top" arrow >
                                                                <IconButton aria-label="AsignarDoi"
                                                                    color="primary" onClick={() => { llamarProductoEditar(row.producto.iddecinvproyectoprodtermin) }}>
                                                                    <MdOutlineHistoryEdu />
                                                                </IconButton>
                                                            </Tooltip>
                                                            : <></>}
                                                    </StyledTableCell>
                                                </StyledTableRow>
                                            );
                                        }) :
                                        <StyledTableRow key={0}>
                                            <StyledTableCell component="th" scope="row"></StyledTableCell>
                                            <StyledTableCell align="left"></StyledTableCell>
                                            <StyledTableCell align="left"></StyledTableCell>
                                            <StyledTableCell align="left">No hubo resultados</StyledTableCell>
                                            <StyledTableCell align="left"></StyledTableCell>
                                            <StyledTableCell align="left"></StyledTableCell>
                                        </StyledTableRow>
                                    }
                                </TableBody>
                                : <CircularProgress disableShrink />
                            }
                        </Table>
                    </TableContainer>
                    <TablePagination
                        rowsPerPageOptions={props.rowsPerPage}
                        component="div"
                        count={filtrarDatos(props.data, filterName).length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </CardBody>
            </Card>
            <ModalStrap isOpen={modal} toggle={toggleModal} className="custom-modal">
                <ModalHeader toggle={toggleModal}>
                    <Typography id="modal-modal-title" variant="h4"><strong>Detalle Producto</strong></Typography>
                </ModalHeader>
                <ModalBody>
                    {ready ?
                        <DetalleProducto datos={datos} token={token} listRolColaborador={listRolColaborador} tipoProductos={tipoProductos} />
                        :
                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                            <CircularProgress color="success" />
                        </Stack>
                    }
                </ModalBody>
            </ModalStrap>
            <ModalStrap isOpen={modalEliminar} toggle={toggleModalEliminar} className="custom-modal">
                <ModalHeader toggle={toggleModalEliminar}>
                    <Typography id="modal-modal-title" variant="h4"><strong>Eliminar Producto</strong></Typography>
                </ModalHeader>
                <ModalBody>
                    {ready ?
                        <>
                            <Grid container spacing={2}>
                                <Grid container spacing={2} sx={{ m: 1 }} alignItems="center" justifyContent="center">
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Typography variant="h5">¿Estás seguro de que deseas eliminar este producto? Esta acción no se puede deshacer.</Typography>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ m: 1 }} alignItems="center" justifyContent="center">
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Typography variant="h5">
                                            <strong>{datos.producto.titulo}</strong>
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </>
                        :
                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                            <CircularProgress color="success" />
                        </Stack>
                    }
                </ModalBody>
                <ModalFooter>
                    <Grid container spacing={2} justifyContent="flex-start">
                        <Grid item xs={12} sm={6} md={4}>
                            {/* <Button variant="contained" color="success" startIcon={<FaWindowClose />} >Cerrar</Button> */}
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} >
                            <Button variant="contained" color="success" startIcon={<FaWindowClose />} onClick={() => { toggleModalEliminar() }}>Cerrar</Button>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} >
                            <Button variant="contained" color="error" startIcon={<AiFillDelete />} onClick={() => { eliminarProducto(datos.producto.iddecinvproyectoprodtermin) }}>Eliminar</Button>
                        </Grid>
                    </Grid>
                </ModalFooter>
            </ModalStrap>
            <ModalStrap isOpen={modalEditar} toggle={toggleModalEditar} className="custom-modal">
                <ModalHeader toggle={toggleModalEditar}>
                    <Typography id="modal-modal-title" variant="h4"><strong>Asignar Doi</strong></Typography>
                </ModalHeader>
                <ModalBody>
                    {ready ?
                        <OldProductoForm
                            idProducto={datos.producto.iddecinvproyectoprodtermin}
                            defaultTipo={datos.producto.iddecinvtipoproductoesperado}
                            productoterminado={datos}
                            categoriasAvalible={[]}
                            tiposAvalible={[]}
                            onResponse={handleResponseDoi}
                        />
                        :
                        <Stack sx={{ color: 'grey.500' }} spacing={2} direction="row">
                            <CircularProgress color="success" />
                        </Stack>
                    }
                </ModalBody>
            </ModalStrap>
        </Paper>
    );
}

function setTipoProductos(objDatos: any): any {
    throw new Error('Function not implemented.');
}
